import { useTranslation } from 'react-i18next';
import { PresentationTreeResponse } from 'entities/tag';
import { TaxonomyWrapper } from 'app/components/editor/sidebar/tags/taxonomy/TaxonomyWrapper';
import { UsedConceptRoles } from 'app/components/editor/sidebar/tags/taxonomy/usedConceptRoles';

interface PresentationTreePaneProps {
  data: PresentationTreeResponse | null | undefined;
  extensionTags?: string[];
  usedConceptRoles?: UsedConceptRoles;
  selectedConceptName: string | null;
  selectedNodeKey: string | null;
  onSelect: (conceptName: string, nodeKey?: string) => void;
}

export const PresentationTreePane = ({ data, extensionTags, usedConceptRoles, selectedConceptName, selectedNodeKey, onSelect }: PresentationTreePaneProps) => {
  const { t } = useTranslation('tag');

  const networks = data?.presentationTree?.networks ?? [];

  if (networks.length === 0) {
    return <div className="tree-overview__pane-empty">{t('treeOverview.empty.presentation')}</div>;
  }

  return (
    <>
      {networks.map((network, idx) => (
        <TaxonomyWrapper
          key={`${network.linkrole.roleURI}|${idx}`}
          {...network}
          selectedTagId={selectedConceptName}
          selectedNodePath={selectedNodeKey}
          expandToIds={null}
          usedConceptRoles={usedConceptRoles}
          extensionTags={extensionTags ?? []}
          onSelectTag={(tag, nodePath) => onSelect(tag.id, nodePath)}
        />
      ))}
    </>
  );
};
